import format from './formatDate';

export function now(): string {
  return new Date().toISOString().substring(0, 19);
}

export function getDefaultTimeOptions() {
  const timeOptions = [];
  const minutes = [0, 30];
  for (let h = 0; h <= 23; h += 1) {
    minutes.forEach((minute) => {
      const time = new Date();
      time.setHours(h);
      time.setMinutes(minute);
      timeOptions.push(format(time, 'HH:mm'));
    });
  }
  return timeOptions;
}

export function compareTimeStrings(a: string, b: string): 1 | 0 | -1 {
  const timeA = parseInt(a.replace(':', ''), 10);
  const timeB = parseInt(b.replace(':', ''), 10);

  if (timeA > timeB) {
    return 1;
  }
  if (timeA < timeB) {
    return -1;
  }

  return 0;
}
export function sortTimeStrings(times: string[] = []): string[] {
  return times.sort(compareTimeStrings);
}
